<template>
  <li class="wf-flex wf-flex-wrap wf-flex-row wf-items-center wf-w-full wf-py-2">
    <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">Text Alignment</span>
    <div class="wf-flex wf-w-1/2">
      <button
        @click.prevent="alignment = 'LEFT'"
        v-show="alignmentClasses.includes('LEFT')"
        class="wf-flex-1 wf-cursor-pointer wf-text-sm"
        :class="alignment == 'LEFT' ? 'wf-text-blue-500' : ''"
      ><i class="fas fa-align-left"></i></button>
      <button
        @click.prevent="alignment = 'CENTER'"
        v-show="alignmentClasses.includes('CENTER')"
        class="wf-flex-1 wf-cursor-pointer wf-text-sm"
        :class="alignment == 'CENTER' ? 'wf-text-blue-500' : ''"
      ><i class="fas fa-align-center"></i></button>
      <button
        @click.prevent="alignment = 'RIGHT'"
        v-show="alignmentClasses.includes('RIGHT')"
        class="wf-flex-1 wf-cursor-pointer wf-text-sm"
        :class="alignment == 'RIGHT' ? 'wf-text-blue-500' : ''"
      ><i class="fas fa-align-right"></i></button>
      <button
        @click.prevent="alignment = 'JUSTIFY'"
        v-show="alignmentClasses.includes('JUSTIFY')"
        class="wf-flex-1 wf-cursor-pointer wf-text-sm"
        :class="alignment == 'JUSTIFY' ? 'wf-text-blue-500' : ''"
      ><i class="fas fa-align-justify"></i></button>
    </div>
  </li>
</template>

<script>
  import { TextAlignmentClasses } from '../classes/TextAlignmentClasses'
  import MenuStyleProperty from '../contracts/MenuStyleProperty'
  export default MenuStyleProperty.extend({
    computed: {
      alignmentClasses() {
        let classes = Object.keys(TextAlignmentClasses)
        return this.except.length ? classes.filter(alignmentClass => ! this.except.includes(alignmentClass)) : classes
      },
      alignment: {
        get() {
          let currentAlignment = this.elementClasses(this.classes)[this.device].find(elementClass => this.alignmentClasses.includes(elementClass.value))
          if (! currentAlignment) {
            currentAlignment = {property: 'TextAlignment', value: 'LEFT', touched: false}
            this.addToArray(this.module, [currentAlignment], this.classes, this.device, {}, true, this.parentModule)
          }
          return currentAlignment.value
        },
        set(value) {
          let currentAlignment = this.elementClasses(this.classes)[this.device].find(elementClass => this.alignmentClasses.includes(elementClass.value))
          value = {property: 'TextAlignment', value: value, touched: currentAlignment.touched}
          this.addToArray(this.module, [value], this.classes, this.device, {}, true, this.parentModule)
        }
      },
    }
  })
</script>